<template>
  <div class="content-swiper" ref="waypointWrapper">

    <div class="row text-center" v-if="title">
      <h4>{{ title }}</h4>
    </div>

    <div class="row" v-if="slides">

      <mq-tabs class="tabs" :selectedIndex="selectedIndex" :items="slides" @select="didSelectedTab">
        <mq-tab slot="tab" slot-scope="props"
          :color="teamsiteConfig.color"
          :icon="itemIcon(props.item)"
          :title="itemTitle(props.item)"
        ></mq-tab>
      </mq-tabs>

      <div class="column">
        <div v-swiper:mySwiper="swiperOptions" ref="swiper">

          <div class="swiper-wrapper" >
            <div class="swiper-slide" v-for="(slide, index) in slides" :key="index">

              <!-- render given slot for this index or default slide -->
              <div v-if="$scopedSlots[`slide-${index}`]" :class="`row collapse slide-${index}`">
                <slot :name="`slide-${index}`" :slide="slide"></slot>
              </div>
              <slide v-else :class="`slide-${index}`" :slide="slide"></slide>

            </div>
          </div>

        </div>
      </div>

    </div>

  </div>
</template>

<script>

require('waypoints/lib/noframework.waypoints.js')
export default {
  name: 'content-swiper',

  props: {
    slides: {
      type: Array,
      required: false,
      default(){
        return []
      }
    },
    title: {
      type: String
    },
  },

  computed: {
    swiper() {
      return this.$refs.swiper.swiper
    }
  },

  methods: {
    didSelectedTab(index) {
      this.swiper.slideTo(index + 1)
    },
    itemIcon (item) {
      if (item.cars_type && item.cars_type.electric && !item.cars_type.petrol) return item.icon_electric
      return item.icon
    },
    itemTitle (item) {
      if (item.cars_type && item.cars_type.electric && !item.cars_type.petrol) return item.title_electric
      if (item.cars_type && item.cars_type.electric && item.cars_type.petrol) return item.title_petrol_and_electric
      return item.title
    }
  },

  mounted () {
    const el = this.$refs.waypointWrapper

    const wp = new Waypoint({
      element: el,
      offset: '105%',
      continuous: false,
      handler: (direction) => {
        if (!this.swiper.params) { return }
        this.swiper.slideTo(1)
        this.swiper.params.autoplay.delay = 15000
        this.swiper.params.autoplay.enabled = true
        this.swiper.params.autoplay.disableOnInteraction = false
        this.swiper.params.autoplay.waitForTransition = false
        this.swiper.autoplay.start()

        // start animation inside every slide
        el.classList.add('start-animation')

        // destroy the trigger to prevent starting again (start once)
        wp.destroy()
      }
    })
  },

  data () {
    return {

      wrapperClass: null,

      selectedIndex: 0,

      swiperOptions: {
        simulateTouch: true,
        followFinger: false,
        speed: 0,
        autoplay: false,
        disableOnInteraction: false,
        loop: true,
        on: {
          slideChange: () => {
            this.selectedIndex = (this.swiper.activeIndex - 1) % this.slides.length
          }
        }
      }

    }
  }

}
</script>

<style lang="scss" scoped>

h4 {
  margin-top: 40px;
  margin-bottom: 40px;
  color: $black;
}

.tabs {
  margin-bottom: 20px;
  @include breakpoint(medium up) {
    margin-bottom: 40px;
  }
}

.content-swiper {
  background-size: cover;
  background-position: bottom right;
  background-image: url('../assets/stripes.svg');
  position: relative;
  transition: color .4s ease;

  &:before, &:after {
    content: " ";
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: -1;
    transition: background-color .4s ease;
  }
  &:after {
    background-color: #ececec;
  }
  &.dark-slide {
    color: white;
    background-image: none;
    z-index: 1;
    &:after {
      background-color: #000;
      opacity: 0.8;
      z-index: -2;
    }
    &:before {
      background-size: cover;
      background-position: bottom right;
      background-image: url('../assets/stripes.svg');
      opacity: 0.1;
      z-index: -1;
    }
  }
}

.swiper-wrapper {
  height: auto;
  @include breakpoint(medium down) {
    height: auto !important;
  }
}

.text, img {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ContentSwiper.vue